export const OWNER_SESSION_TTL_MS = 30 * 60 * 1000;

const TOKEN_KEY = "sa_token";
const USER_KEY = "sa_user";
const EXPIRES_AT_KEY = "sa_expires_at";

export function getOwnerSessionExpiry() {
  const expiry = Number(localStorage.getItem(EXPIRES_AT_KEY));
  return Number.isFinite(expiry) && expiry > 0 ? expiry : null;
}

export function isOwnerSessionExpired() {
  const expiry = getOwnerSessionExpiry();
  return expiry === null || expiry <= Date.now();
}

export function saveOwnerSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + OWNER_SESSION_TTL_MS));
}

export function clearOwnerSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}
